<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý đơn hàng: {{title}}</strong>
          <div class="card-header-actions">
            <CButton type="button" shape="pill" color="info" class="mr-1" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="projects"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' '}"
            :itemsPerPage="100"
            column-filter
            hover
            sorter
            pagination
            clickable-rows
            @row-clicked="rowClicked"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #stt="{item, index}">
              <td>
                {{index+1}}
              </td>
            </template>

            <template #status="{item, index}">
              <td>
                <CBadge :color="statusColor(item.status)">
                  {{item.status}}
                </CBadge>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Table column headers
      title: '',
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Sản phẩm', _classes: 'font-weight-bold' },
        { key: 'contract', label: 'Hợp đồng' },
        { key: 'preorder', label: 'Mã đặt hàng' },
        { key: 'quantity', label: 'S/L', _style:'width:3rem;' },
        { key: 'status', label: 'Trạng thái' },
        { key: 'start', label: 'Bắt đầu' },
        { key: 'stop', label: 'Kết thúc' },
      ],
      // Data for projects
      projects: []
    };
  },
  mounted() {
    this.title = this.$route.name;
    // console.log('created: ', this.$route.path, this.title)
  },
  watch: {
    $route(to, from) {
      this.title = this.$route.name;
      this.fetchData();
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(){
      // console.log('fetchData');
      if (localStorage.getItem('role') === 'customer') {
        this.getProjects(localStorage.getItem('username'))
      } else {
        this.getProjects()
      }
    },
    getProjects(custom) {
      if (custom) {
        this.$request.get(`/api/project_custom/${custom}?filter=${this.title}`).then(res => {
          // console.log(res.data)
          this.projects = res.data.projects
        })
      } else {
        this.$request.get(`/api/project?filter=${this.title}`).then(res => {
          // console.log(res.data)
          this.projects = res.data.projects
        })
      }
    },
    rowClicked(item, index) {
      // console.log(item)
      this.editProject(item.id)
    },
    createNew(){
      this.editProject()
    },
    editProject(id) {
      //// console.log('request edit project', id)
      this.$router.push({
        path: '/customer/create',
        query: {
          id: id
        }
      });
    },
    statusColor(status) {
      switch (status) {
        case "Đang thực hiện":
          return "success";
        case "Sắp quá hạn":
          return "warning";
        case "Quá hạn":
          return "danger";
        case "Hoàn thành":
          return "primary";
        default:
          return "secondary";
      }
    },
  }
};
</script>
